/**
 * Vier wiederverwendbare CTA-Varianten – je eine pro Partner-Marke des
 * futuredoctor-Netzwerks. Gestaltung als kompakte Split-Card im Stil von
 * future-doctor.de (Bild links, heller Textbereich rechts, Cyan-Button).
 *
 * Ziel je Variante:
 *  – future-doctor.de / travel4med.de / tmsbuddies.de: externer Link.
 *  – ncrechner: öffnet das „App kostenlos laden"-Popup (kein Seitenwechsel).
 *
 * Beim Laden wird zufällig eine Startvariante gewählt; danach rotieren die
 * Varianten nach jedem dritten Abschnitt.
 */
export type CtaVariant = {
  id: string;
  eyebrow: string;
  heading: string;
  description: string;
  buttonLabel: string;
  /** Externes Ziel des Buttons (entfällt, wenn `appPopup` gesetzt ist). */
  buttonHref?: string;
  /** true → Button öffnet das App-Download-Popup statt zu verlinken. */
  appPopup?: boolean;
  backgroundImage: string;
};

export const CTA_VARIANTS: CtaVariant[] = [
  {
    id: "future-doctor",
    eyebrow: "future-doctor",
    heading: "Medizinstudium ganz ohne Numerus Clausus.",
    description: "Starte dein Medizinstudium ganz einfach im Ausland. An renommierten Universitäten in Städten wie Budapest, Prag oder Riga.",
    buttonLabel: "Infomaterial downloaden",
    buttonHref: "https://www.future-doctor.de/futuredoctor-infopaket/?utm_source=ncrechner&utm_medium=website&utm_campaign=referral",
    backgroundImage: "/images/blog/cta-fristen.jpg",
  },
  {
    id: "travel4med",
    eyebrow: "travel4med",
    heading: "Pflegepraktikum, Famulatur und PJ auf Sri Lanka!",
    description: "Kombiniere Urlaub mit deinen Pflichtpraktika. Ganz einfach auf Sri Lanka, Nepal oder Bali.",
    buttonLabel: "Mehr erfahren",
    buttonHref: "https://www.travel4med.de/?utm_source=ncrechner&utm_medium=website&utm_campaign=referral",
    backgroundImage: "/images/blog/theme-world-travel.jpg",
  },
  {
    id: "tmsbuddies",
    eyebrow: "tmsbuddies",
    heading: "Du willst Medizin studieren? Dann zählt jeder Punkt im TMS!",
    description: "Probiere den kostenlosen 10h-Kurs aus. So bekommst du ein Gefühl für die Aufgabentypen und kannst dich in Ruhe mit dem Medizinertest vertraut machen.",
    buttonLabel: "10h Gratiskurs testen",
    buttonHref: "https://tmsbuddies.de/produkt/10h-kostenloser-kurs/?utm_source=ncrechner&utm_medium=website&utm_campaign=referral",
    backgroundImage: "/images/blog/cta-tms.jpg",
  },
  {
    id: "ncrechner",
    eyebrow: "ncrechner App",
    heading: "Der NC-Rechner für deinen Medizinstudienplatz!",
    description: "Die Vergabe von Medizinstudienplätzen ist kompliziert und alleine kaum durchschaubar. Mit dem NCRechner hast du ein Tool, das deine Chancen an allen staatlichen Universitäten in Deutschland berechnet. So siehst Du sofort, wo Du die besten Aussichten hast und kannst deine Chancen gezielt verbessern.",
    buttonLabel: "App kostenlos laden",
    appPopup: true,
    backgroundImage: "/images/blog/cta-chancen.jpg",
  },
  {
    id: "dein-medizinstudium",
    eyebrow: "dein-medizinstudium",
    heading: "Alles rund um deine Zulassung zum Medizinstudium.",
    description: "Detaillierte Infos zu Zulassungsvoraussetzungen, Auswahlverfahren und ein Vergleich aller deutschen Hochschulen – an einem Ort.",
    buttonLabel: "Mehr erfahren",
    buttonHref: "https://www.dein-medizinstudium.de/?utm_source=ncrechner&utm_medium=website&utm_campaign=referral",
    backgroundImage: "/images/blog/medizin-zulassung-guide.jpg",
  },
];

/** Standardvariante (u. a. für den CTA am Ende der Kategorie-Seiten). */
export const CTA_DEFAULT: CtaVariant = CTA_VARIANTS[3];

/** Liefert die CTA-Variante für Position i (0-basiert, zyklisch, negativ-sicher). */
export function ctaForIndex(i: number): CtaVariant {
  const n = CTA_VARIANTS.length;
  return CTA_VARIANTS[((i % n) + n) % n];
}
